import Add from '@mui/icons-material/Add';
import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import Star from '@mui/icons-material/Star';
import StarBorder from '@mui/icons-material/StarBorder';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { hasErrors } from '../../../common/enums';
import { GalleryComment, newGalleryComment } from '../../../common/models/galleryComment';
import { selectFranchiseComments } from '../../../common/selectors/comments';
import { userLogged } from '../../../common/selectors/user';
import { adminSlice } from '../../../common/store/admin';
import { galleryCommentSlice } from '../../../common/store/galleryComments';
import { AppState, appStore, franchiseSelector } from '../../../common/store/store';
import { deleteData, postData } from '../../api';
import { ReviewBox } from '../ReviewBox';


const NewReviewForm = () => {

    const item = useSelector((state: AppState) => state.admin.newGalleryComment);
    const user = useSelector((state: AppState) => userLogged(state));

    const onChange = (value: Partial<GalleryComment>) => {
        console.log('value', value);
        console.log('item', item);
        appStore.dispatch(adminSlice.actions.updateNewGalleryComment({ ...item, ...value }));
    };

    const onSaved = () => {
        if (user?.franchiseId) {
            appStore.dispatch(adminSlice.actions.updateNewGalleryComment({
                ...newGalleryComment,
                franchiseId: user.franchiseId
            }));
        }
    };

    React.useEffect(() => {
        if (user?.franchiseId) {
            onChange({ franchiseId: user.franchiseId });
        }
    }, [user]);

    if (!item) return <></>;

    return <ReviewForm comment={item} onChange={onChange} onSaved={onSaved} />;
};

const ExistingReviewForm = () => {

    const item = useSelector((state: AppState) => state.admin.editGalleryComment);


    const onChange = (value: Partial<GalleryComment>) => {
        if (item) {
            appStore.dispatch(adminSlice.actions.updateEditGalleryComment({ ...item, ...value }));
        }
    };
    const onSaved = () => {
        appStore.dispatch(adminSlice.actions.updateEditGalleryComment(undefined));
    };

    if (!item) return <></>;

    return <ReviewForm comment={item} onChange={onChange} onSaved={onSaved} />;
};

const ReviewForm = (props: { comment: GalleryComment, onChange: (value: Partial<GalleryComment>) => void, onSaved: () => void; }) => {

    const [err, setErr] = React.useState<ResponseError[] | undefined>();
    const franchises = useSelector((state: AppState) => franchiseSelector.selectAll(state));


    const onSaveClick = async () => {
        const result = await postData<GalleryComment>('galleryComments', props.comment);
        if (hasErrors(result)) {
            setErr(result);
        } else {
            appStore.dispatch(galleryCommentSlice.actions.upsertOne(result));
            props.onSaved();
        }
    };

    if (!props.comment) return <></>;

    return <><Typography variant='h3'>{props.comment.id ? 'Modifier' : 'Ajouter'} un commentaire</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', maxWidth: 500, bgColor: 'background.paper' }}>
            <Box sx={{ flex: 1, p: 1 }}>
                <ButtonGroup>
                    <IconButton onClick={() => { props.onChange({ stars: 1 }); }}>{props.comment.stars >= 1 ? <Star sx={{ color: 'yellow' }} /> : <StarBorder sx={{ color: 'yellow' }} />}</IconButton>
                    <IconButton onClick={() => { props.onChange({ stars: 2 }); }}>{props.comment.stars >= 2 ? <Star sx={{ color: 'yellow' }} /> : <StarBorder sx={{ color: 'yellow' }} />}</IconButton>
                    <IconButton onClick={() => { props.onChange({ stars: 3 }); }}>{props.comment.stars >= 3 ? <Star sx={{ color: 'yellow' }} /> : <StarBorder sx={{ color: 'yellow' }} />}</IconButton>
                    <IconButton onClick={() => { props.onChange({ stars: 4 }); }}>{props.comment.stars >= 4 ? <Star sx={{ color: 'yellow' }} /> : <StarBorder sx={{ color: 'yellow' }} />}</IconButton>
                    <IconButton onClick={() => { props.onChange({ stars: 5 }); }}>{props.comment.stars >= 5 ? <Star sx={{ color: 'yellow' }} /> : <StarBorder sx={{ color: 'yellow' }} />}</IconButton>
                </ButtonGroup>
            </Box>
            <Box sx={{ flex: 1, p: 1 }}>
                <TextField
                    fullWidth
                    size='small'
                    label='Auteur du commentaire'
                    value={props.comment.author ?? ''}
                    onChange={event => {
                        props.onChange({ author: event.target.value });
                    }}
                    error={!!err?.find(p => p.param == 'author')}
                    helperText={err?.find(p => p.param == 'author')?.msg}
                />
            </Box>
            <Box sx={{ flex: 1, p: 1 }}>
                <TextField
                    size='small'
                    fullWidth
                    value={props.comment.comment ?? ''}
                    onChange={event => {
                        props.onChange({ comment: event.target.value });
                    }}
                    label='Commentaire client'
                    multiline
                    rows={3}
                    error={!!err?.find(p => p.param == 'comment')}
                    helperText={err?.find(p => p.param == 'comment')?.msg ?? (props.comment.comment.length + ' car.')}
                />
            </Box>
            <Box sx={{ flex: 1, p: 1 }}>
                <FormControl fullWidth>
                    <InputLabel id="franchise-id-label">Franchise</InputLabel>
                    <Select
                        labelId="franchise-id-label"
                        label='Franchise'
                        id="franchise-id"
                        fullWidth
                        value={props.comment.franchiseId ?? ''}
                        onChange={event => {
                            console.log('event.target.value', event.target.value);
                            if (typeof event.target.value == 'number') {
                                props.onChange({ franchiseId: event.target.value });
                            } else if (typeof event.target.value == 'string' && parseInt(event.target.value)) {
                                props.onChange({ franchiseId: parseInt(event.target.value) });
                            } else {
                                props.onChange({ franchiseId: null });
                            }
                        }}>
                        <MenuItem value=''>Aucune</MenuItem>
                        {franchises.map(franchise => <MenuItem key={franchise.id} value={franchise.id}>{franchise.name}</MenuItem>)}
                    </Select>
                </FormControl>
            </Box>
            <Box sx={{ flex: 1, p: 1 }}>
                <FormControlLabel control={<Checkbox checked={props.comment.general === true} />} onChange={() => {
                    props.onChange({ general: !props.comment.general });
                }} label="Afficher sur toutes les franchises" />
            </Box>
            <Box sx={{ flex: 1 }}>
                <Button variant='contained' onClick={onSaveClick} size='large'>{props.comment.id ? 'Modifer' : 'Ajouter'}</Button>
            </Box>
        </Box>
    </>;
};

const CommentPrimary = (props: { comment: GalleryComment; }) => {
    return <><Typography component='span'><strong>{props.comment.author}</strong></Typography>{[1, 2, 3, 4, 5].map((star) => {
        if (props.comment.stars >= star) {
            return <Star key={star} sx={{ color: 'yellow' }} />;
        } else {
            return <StarBorder key={star} sx={{ color: 'yellow' }} />;
        }
    })}</>;
};

export const Reviews = () => {

    const comments = useSelector((state: AppState) => selectFranchiseComments(state));

    const editGalleryComment = useSelector((state: AppState) => state.admin.editGalleryComment);
    const editComment = (comment: GalleryComment | undefined) => {
        appStore.dispatch(adminSlice.actions.updateEditGalleryComment(comment));
    };

    const deleteComment = async (comment: GalleryComment) => {
        if (confirm(`Supprimer le commentaire de ${comment.author ?? '(auteur inconnu?)'} ?`)) {
            const result = await deleteData('galleryComments', comment.id);
            if (result) {
                appStore.dispatch(galleryCommentSlice.actions.removeOne(comment.id));
            } else {
                alert('Une erreur est survenue');
            }
        }
    };
    const addComment = () => {
        editComment({ ...newGalleryComment });
    };

    return <Master><Container maxWidth={false}>
        <Typography variant='h1'>Commentaires Google</Typography>
        {editGalleryComment ? <Dialog open={true} onClose={() => editComment(undefined)}>
            <DialogContent>
                <ExistingReviewForm />
            </DialogContent>
        </Dialog> : null}
        <Box>
            <Box className='reviewBoxItem' key={'new'} sx={{ position: 'relative', display: 'inline-block', margin: '2px', width: 200, height: 150 }}>
                <Box sx={{
                    width: 200, height: 150,
                    border: '2px dotted grey',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white'
                }}>
                    <IconButton onClick={() => addComment()} color='primary'><Add /></IconButton>
                </Box>
            </Box>
            {comments.map(comment => <Box className='reviewBoxItem' key={comment.id} sx={{ position: 'relative', display: 'inline-block', margin: '2px', width: 200, height: 150 }}>
                <Box className='reviewBoxEdit' sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: 200, height: 150,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white'
                }}>
                    <IconButton onClick={() => editComment(comment)} color='primary'><Edit /></IconButton>
                    <IconButton onClick={() => deleteComment(comment)} color='error'><Delete /></IconButton>
                </Box>
                <ReviewBox
                    sx={{ width: 200, height: 150 }}
                    review={comment} />
            </Box>)}
        </Box>
    </Container></Master>;
};
